import React, {  } from 'react';
import { useSelector } from 'react-redux';

import PositionsMap from './ClusterMap';

const CurrentPositionsMap = ({numberPlateState}) => {
  const positions = useSelector(state => Object.values(state.positions.items));
  return (<PositionsMap numberPlateState= {numberPlateState} positions={positions} />);
}

export default CurrentPositionsMap;
